import React, { Suspense } from 'react'
import { Canvas } from 'react-three-fiber'
// import { Canvas as CanvasFiber } from 'react-three-fiber'
// import { Controls, withControls } from 'react-three-gui'
import { IS_DEVELOPMENT } from '../../config'
import {
  // DeveloperOnly,
  Environment,
  Lightnings,
  Objects,
} from '../../components'

// const Canvas = withControls(CanvasFiber);

const Home = ({ history }) => {
  return (
    // <Controls.Provider>
      <Suspense fallback={null}>
        <Canvas
          style={{ width: '100vw', height: '100vh'}}
          // concurrent
          // onCreated={() => console.log('created')}
          gl={{
            powerPreference: 'high-performance',
            alpha: false,
            antialias: false,
            stencil: false,
            depth: false,
          }}
          camera={{
            isPerspectiveCamera: true,
            fov: 60,
            aspect: window.innerWidth / window.innerHeight,
            near: 0.01,
            far: 100,
          }}
          invalidateFrameloop={IS_DEVELOPMENT}
        >
          <Suspense fallback={null}>
            {/* <DeveloperOnly /> */}
            <Environment>
              <Objects history={history} />
              <Lightnings />
            </Environment>
          </Suspense>
        </Canvas>
        {/* <Controls
          title="Genesys 2021 - Admin"
          collapsed={false}
          defaultClosedGroups={[
            'Box',
            'Cone',
            'Sphere',
            'TorusKnot',
            'Torus',
            'Dodecahedron',
          ]}
        /> */}
      </Suspense>
    // </Controls.Provider>
  )
}

export default Home
